import type { IconProps } from '../types/IconProps.ts';
export const Smile: IconProps = {
    name: 'Smile',
    children: [
        `<circle cx="12" cy="12" r="10" />`,
        `<path d="M7 15a6.14 6.14 0 0 0 10 0" />`,
        `<circle cx="8" cy="10" r=".5" />`,
        `<circle cx="16" cy="10" r=".5" />`,
    ]
};